// @flow strict

import { Alert, Avatar, Button, Divider, List, Modal, Tag } from 'antd';
import { useEffect, useState } from 'react';
import { Toaster, toast } from 'react-hot-toast';
import { LuUser2 } from "react-icons/lu";
import { retrieveUserProfile } from '../../../api/profile';
import { generateReferralCode, getReferedUsers } from '../../../api/user';
import { getUserID } from '../../../Utility/service';
import { getReferralUrl } from '../../../Utility/utility';
import RedeemRules from './RedeemRules';

function ReferralProgram() {
  const userId = getUserID();
  const [userInfo, setUserInfo] = useState({});
  const [loading, setLoading] = useState(false);
  const [referralUsers, setReferralUsers] = useState([]);
  const [point, setPoint] = useState(0);
  const [openRedeem, setOpenRedeem] = useState(false);

  const handleGenerateRef = async () => {
    setLoading(true);

    try {
      const res = await generateReferralCode(userId);
      const user = res.data.profile;
      setUserInfo(user);
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    };
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(getReferralUrl(userInfo))
      .then(() => {
        toast.success('Referral link copied to clipboard');
      })
      .catch(err => {
        toast.error('Failed to copy: ', err?.message);
      });
  };

  const fetchReferedUsers = async () => {
    const res = await getReferedUsers();
    setPoint(res.data?.point || 0)
    setReferralUsers(res.data.users);
  };

  useEffect(() => {
    retrieveUserProfile(userId).then((user) => {
      setUserInfo(user);
    });

    fetchReferedUsers();
  }, [userId]);

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <div className="user-referral container px-3 px-md-5 py-3">

        <div className="user-refer-points">
          <Alert
            className="referral-points-area"
            description={
              <div className="referral-points">
                <p className="ref-point my-0">{point || 0}</p>
                <p className="my-0 ref-text">Available Points</p>
              </div>
            }
            type="success"
          />
          <Button onClick={() => setOpenRedeem(true)} type="primary">
            Redeem Now
          </Button>
        </div>

        <Alert
          message={<span className="refer-headline">Invite and Win Rewards!</span>}
          description={
            <div className="d-flex flex-column">
              {
                userInfo?.refCode ?
                  <div className="d-flex align-items-center flex-md-row flex-column gap-2 my-3">
                    <p className="border border-info px-3 py-1 my-0 rounded-2">
                      {getReferralUrl(userInfo)}
                    </p>
                    <Button className="refer-btn" onClick={handleCopy}>
                      Copy Link
                    </Button>
                  </div>
                  :
                  <div className="my-2">
                    <Button
                      onClick={handleGenerateRef}
                      loading={loading}
                      className="text-primary refer-btn"
                    >
                      Generate Referral Link
                    </Button>
                  </div>
              }
              <p>
                Invite your friends and family to join the Collaborative AI community and earn <b>20 points</b> for each successful new paid user.
              </p>
            </div>
          }
          type="info"
          showIcon
          className="mb-3"
        />

        <List
          header={<span className="refer-headline">
            {referralUsers.length} Users have used your <span className="text-info">Referral Link</span>.
          </span>}
          itemLayout="horizontal"
          dataSource={referralUsers}
          bordered
          renderItem={(item, index) => (
            <List.Item>
              <List.Item.Meta
                avatar={<Avatar size={40} icon={<LuUser2 />} />}
                title={<span>{item?.fname + " " + item?.lname}</span>}
                description={item?.email}
              />
              <Tag color="success">
                {new Date(item?.createdAt).toDateString()}
              </Tag>
            </List.Item>
          )}
        />
      </div>

      <Modal
        title={<h5>Redeem and Get Extra Reward!</h5>}
        open={openRedeem}
        onCancel={() => setOpenRedeem(false)}
        footer={false}
      >
        <Divider />
        <RedeemRules  userInfo={userInfo} point={point} />
      </Modal>
    </>
  );
};

export default ReferralProgram;